import * as Yup from "yup";

const optionalNumericString = message =>
  Yup.string()
    .nullable()
    .test(
      "digits-only",
      message,
      value => value == null || value === "" || /^\d+$/.test(value),
    );

const buildUpdateBankAccountValidationSchema = ({
  validateBankDetails = true,
} = {}) => {
  if (!validateBankDetails) {
    return Yup.object();
  }

  return Yup.object({
    bank: Yup.string().required("Please enter the bank name"),
    number: optionalNumericString(
      "Account number can only contain numbers",
    ),
    sortCode: optionalNumericString("Sort code can only contain numbers"),
    holder: Yup.string().required("Please enter the account holder name"),
    currencyId: Yup.number().required("Please select a currency"),
    iban: Yup.string().nullable(),
    swift: Yup.string().nullable(),
  });
};

export { buildUpdateBankAccountValidationSchema };
